var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "personal-panel" }, [
    _c(
      "div",
      {
        staticClass: "personal-desc",
        style: { background: this.$store.state.app.themeColor }
      },
      [
        _c("div", { staticClass: "avatar-container" }, [
          _c("img", { staticClass: "avatar", attrs: { src: _vm.logo } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "name-role" }, [
          _c("span", { staticClass: "sender" }, [_vm._v(_vm._s(_vm.user.name))])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "main-operation" }),
    _vm._v(" "),
    _c("div", { staticClass: "personal-footer", on: { click: _vm.logout } }, [
      _c("li", { staticClass: "fa fa-sign-out" }),
      _vm._v("\n    " + _vm._s(_vm.$t("common.logout")) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccd87a64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccd87a64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Core/PersonalPanel.vue
// module id = null
// module chunks = 